import React, { useEffect, useState } from 'react';
import { AiOutlineBell, AiOutlineUser } from 'react-icons/ai';
import { FaBars, FaChartBar, FaCogs, FaHandshake, FaUser, FaBell, FaList, FaCog, FaUsers, FaUpload, FaMoneyBill, FaSignOutAlt, FaBoxOpen, FaTimes } from 'react-icons/fa';
import { FaListCheck } from 'react-icons/fa6';
import { MdDashboard, MdSecurity } from 'react-icons/md';
import { Outlet, useLocation, NavLink  } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import { toast } from 'react-toastify';
import axios from 'axios';
import { rootUrl } from '../helpers';
import { BiHome } from 'react-icons/bi';


export default function AdminLayout() {

    const auth = useAuth();

    const check = async () =>{
      try{
        const response = await axios.get(rootUrl(`/checkUser/${auth.user?.id}`))
        if(response.data.status != 200){
             window.location.href = "/"
        }
      }catch(e){
        window.location.href = "/"
      }
    }

    useEffect(()=>{
      check()
    }, [])

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const location = useLocation();
    const currentUrl = location.pathname + location.search;
  
    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    };
  
    const routes = [
      { path: '/admin', name: 'Dashboard', icon: MdDashboard },
      { path: '/admin/users', name: 'Users', icon: FaUsers },
      { path: '/admin/budget', name: 'Budget', icon: FaMoneyBill },
      { path: '/admin/opening', name: 'Open', icon: FaBoxOpen },
      { path: '/admin/settings', name: 'Setting', icon: FaCog },
      // { path: '/admin/audit', name: 'Audit', icon: MdSecurity },
      { path: '/admin/input', name: 'Upload', icon: FaUpload },
    ];

    const signOut = () => {

      auth.logOut(()=>{
        window.location.reload()
      })
  
    }

return (
    <div className="flex h-screen bg-gray-50 overflow-hidden">
      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={toggleSidebar}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed lg:static inset-y-0 left-0 z-50
          w-64 bg-gradient-to-b from-blue-950 to-blue-900 text-white
          transform transition-transform duration-300 ease-in-out
          ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
          flex flex-col shadow-2xl
        `}
      >
        {/* Sidebar Header */}
        <div className="p-6 border-b border-blue-800">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <div className="bg-white/20 rounded-lg p-2">
                <img src="/logo.jpg" alt="Logo" className="w-8 h-8 object-contain" />
              </div>
              <div>
                <h2 className="font-bold text-lg">Gramosi</h2>
                <p className="text-xs text-blue-200">Admin Panel</p>
              </div>
            </div>
            <button
              onClick={toggleSidebar}
              className="lg:hidden p-2 hover:bg-white/10 rounded-lg transition-colors"
            >
              <FaTimes className="text-white" />
            </button>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto px-4 py-4">
          <p className="text-xs font-semibold text-blue-300 uppercase tracking-wider mb-3 px-3">
            Navigation
          </p>
          <ul className="space-y-1">
            {routes.map((route) => {
              const isActive = currentUrl === route.path;
              return (
                <li key={route.path}>
                  <NavLink
                    to={route.path}
                    onClick={() => setIsSidebarOpen(false)}
                    className={`
                      flex items-center gap-3 px-4 py-3 rounded-lg
                      transition-all duration-200
                      ${
                        isActive
                          ? 'bg-white text-blue-950 shadow-lg font-semibold'
                          : 'text-blue-100 hover:bg-white/10 hover:text-white'
                      }
                    `}
                  >
                    {React.createElement(route.icon, {
                      className: `text-lg ${isActive ? 'text-blue-950' : 'text-blue-300'}`
                    })}
                    <span>{route.name}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>

        {/* Sidebar Footer - User Info & Logout */}
        <div className="p-4 border-t border-blue-800">
          <div className="flex items-center gap-3 mb-3 px-2">
            <div className="bg-white/20 rounded-full p-2">
              <FaUser className="text-white text-sm" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-white truncate">
                {auth.user?.name || 'Admin User'}
              </p>
              <p className="text-xs text-blue-200 truncate">
                {auth.user?.email || 'admin@gramosi.com'}
              </p>
            </div>
          </div>
          <button
            onClick={signOut}
            className="w-full flex items-center gap-3 px-4 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors font-medium text-sm"
          >
            <FaSignOutAlt />
            <span>Logout</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Header */}
        <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-sm border-b border-gray-200 shadow-sm">
          <div className="px-4 lg:px-6 py-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-4">
                <button
                  onClick={toggleSidebar}
                  className="lg:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors"
                >
                  <FaBars className="text-gray-700 text-xl" />
                </button>
                <div>
                  <h1 className="text-xl md:text-2xl font-bold text-gray-900">
                    Admin Dashboard
                  </h1>
                  <p className="text-sm text-gray-500 hidden sm:block">
                    Manage your system settings and configurations
                  </p>
                </div>
              </div>
              
              <div className="flex items-center gap-2">
                <NavLink
                  to="/"
                  className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors relative"
                  title="Go to User Dashboard"
                >
                  <BiHome className="text-gray-700 text-xl" />
                </NavLink>
                <button
                  className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors relative"
                  title="Notifications"
                >
                  <AiOutlineBell className="text-gray-700 text-xl" />
                  <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full"></span>
                </button>
                <div className="hidden sm:flex items-center gap-3 ml-2 pl-3 border-l border-gray-200">
                  <div className="bg-blue-950 rounded-full p-2">
                    <FaUser className="text-white text-sm" />
                  </div>
                  <div className="hidden md:block">
                    <p className="text-sm font-medium text-gray-900">
                      {auth.user?.name || 'Admin'}
                    </p>
                    <p className="text-xs text-gray-500">Administrator</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>

        {/* Main Content Area */}
        <main className="flex-1 min-h-0 px-4 lg:px-6 py-4 lg:py-6 overflow-y-auto overflow-x-hidden">
          <div className="max-w-7xl mx-auto w-full">
            <Outlet />
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 px-4 lg:px-6 py-4">
          <div className="max-w-7xl mx-auto">
            <p className="text-center text-sm text-gray-600">
              &copy; 2025 Gramosi. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );

}